module.exports = __webpack_public_path__ + "img/edit.35a3fb95.svg";